import Typography from 'typography';

const typography = new Typography({
    baseFontSize: '15px',
    baseLineHeight: 1.5,
    googleFonts: [
        {
            name: 'Source Sans Pro',
            styles: ['400', '500', '600', '700'],
        },
    ],
    headerFontFamily: ['Source Sans Pro', 'montserrat', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
    bodyFontFamily: ['Source Sans Pro', 'montserrat', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
});

export default typography;
